const fr = {
    // generic
    "close": "Fermer",
    "loading": "Chargement...",

    // OPS page
    "public.ops.404.title": "Oups, quelque chose s’est mal passé.",
    "public.ops.404.subtitle": "La page que vous cherchez n’existe plus ou n’a pas été trouvée.",

    "public.ops.country_disabled.title": "Pays non disponible",
    "public.ops.country_disabled.subtitle": "Nous sommes désolés, mais le programme n’est pas encore disponible dans votre pays.",

    "public.ops.country_mismatch.title": "Pays non correspondant",
    "public.ops.country_mismatch.subtitle": "Le pays associé à votre profil loyalty ne correspond pas à celui de votre compte B2C. Veuillez contacter le support pour obtenir de l’aide.",

    "public.ops.generic.title": "Une erreur s’est produite.",
    "public.ops.generic.subtitle": "Découvrez les conditions pour participer au programme de fidélité GEWISS Passion.",

    "public.ops.cta.label": "Retournez en arrière",

    // welcome page
    "public.welcome.title": "Bienvenue sur",
    "public.welcome.subtitle": "Installez des produits Gewiss et cumulez des points pour acceder au catalogue des cadeaux.",
    "public.welcome.cta.login": "Se connecter",
    "public.welcome.cta.signup": "Créer un compte",
    "public.welcome.cta.discover": "En savoir plus",
    "public.welcome.howto.title": "Comment fonctionne Gewiss Passion?",
    "public.welcome.howto.lead": "Gagner des cadeaux est simple et rapide.",
    "public.welcome.howto.step1.title": "1. Achetez des produits Gewiss",
    "public.welcome.howto.step1.text": "Chaque achat vous permet de gagner des points et vous rapproche de vos cadeaux préférées.",
    "public.welcome.howto.step2.title": "2. Téléchargez votre facture",
    "public.welcome.howto.step2.text": "Prenez une photo ou téléchargez le PDF : vérification rapide, points crédités en quelques jours, et tout est géré depuis le portail ou l’application web.",
    "public.welcome.howto.step3.title": "3. Relevez les défis",
    "public.welcome.howto.step3.text": "Répondez aux enquêtes, regardez des vidéos de formation et testez vos connaissances avec des quiz : chaque activité est une occasion supplémentaire de gagner des points. Consultez régulièrement l’application pour rester informé des défis en cours.",
    "public.welcome.howto.step4.title": "4. Choisissez et demandez votre cadeaux",
    "public.welcome.howto.step4.text": "Objectif de points atteint ? Parcourez le catalogue et demandez votre cadeau quand vous le souhaitez. À vous de jouer.",

    // onboard
    "public.onboard.title": "Complétez votre profil fidélité",
    "public.onboard.subtitle": "Vérifiez et complétez les informations de votre entreprise afin de finaliser votre inscription",
    "public.onboard.form.submit.label": "Accéder au programme",
    "public.onboard.form.submitting.label": "Accéder au programme ...",

    "public.onboard.form.labels.vat": "Numéro de TVA *",
    "public.onboard.form.labels.business_name": "Raison sociale *",
    "public.onboard.form.labels.business_email": "E-mail *",
    "public.onboard.form.descriptions.business_email":
        "Saisissez l’adresse e-mail de l’entreprise. Nous l’utiliserons pour vous informer de votre adhésion au programme.",

    "public.onboard.form.labels.t_and_c": "",
    "public.onboard.form.labels.t_and_c_text":
        "Je déclare avoir pris connaissance de la <a href='https://www.gewiss.com/fr/fr/about-gewiss/privacy-policy' target='_blank'>Politique de confidentialité</a> et accepter le <a href='https://cdn.jnext-it.jakala.cloud/IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf' target='_blank'>règlement</a>.",
    "public.onboard.form.labels.agree": "Confirmer",
    "public.onboard.form.labels.decline": "Je n’accepte pas",

    "public.onboard.form.validation.vat_required": "Numéro de TVA obligatoire",
    "public.onboard.form.validation.vat_too_short": "Numéro de TVA non valide",
    "public.onboard.form.validation.business_name_required": "La raison sociale est obligatoire",
    "public.onboard.form.validation.business_name_too_short": "La raison sociale est trop courte",
    "public.onboard.form.validation.business_email_required": "Adresse e-mail obligatoire",
    "public.onboard.form.validation.business_email_invalid": "Adresse e-mail non valide",
    "public.onboard.form.validation.gdpr_required": "Les conditions sont obligatoires",
    "public.onboard.form.validation.field_required": "Champ obligatoire",

    "public.onboard.form.feedback.vat_invalid.title": "Numéro de TVA invalide.",
    "public.onboard.form.feedback.vat_invalid.message": "Numéro de TVA non valide",
    "public.onboard.form.feedback.vat_invalid.label": "Fermer",
    "public.onboard.form.feedback.vat_already_used.message": "L'inscription ne peut pas être finalisée. Le code de TVA saisi est déjà enregistré.",

    "public.onboard.form.feedback.generic_error.title": "Échec.",
    "public.onboard.form.feedback.generic_error.label": "Fermer",
    "public.onboard.form.feedback.generic_error.message": "Veuillez réessayer.",

    // footer
    "public.footer.text":
        "Siège social : Via Domenico Bosatelli 1 - 24 069 CENATE SOTTO BG – Italia - Code fiscal et numéro de TVA, inscrite à la Chambre de commerce de Bergame, à Bergame, sous le numéro : 00385040167 - Copyright ©2026 - Capital social libéré de 60.010.000,00 EUR. Société soumise à la gestion et à la coordination de Polifin S.p.A.",
    "public.footer.links.rules.label": "Règlement",
    "public.footer.links.rules.link": "IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf",
    "public.footer.links.privacy.label": "Politique de confidentialité",
    "public.footer.links.privacy.link": "https://www.gewiss.com/fr/fr/about-gewiss/privacy-policy",
    "public.footer.links.cookie.label": "Cookie Policy",

    "footer:unsubscribe_program": "Se désinscrire du programme",
    "unsubscribe:modal:title": "Confirmer la désinscription",
    "unsubscribe:modal:text": "Vous êtes sur le point d’envoyer une demande de désinscription au programme.",
    "unsubscribe:modal:fineprint": "Votre demande sera traitée dans un délai de {{days}} jours ouvrés.",
    "unsubscribe:modal:cta": "Confirmer la désinscription",

    "unsubscribe:modal:loading:title": "Envoi de la demande",
    "unsubscribe:modal:loading:text": "Nous envoyons votre demande de désinscription.",

    "unsubscribe:modal:success:title": "Demande envoyée",
    "unsubscribe:modal:success:text": "Votre demande de désinscription a été envoyée avec succès.",
    "unsubscribe:modal:success:label": "Fermer",

    "unsubscribe:modal:error:text": "Une erreur s’est produite lors de l’envoi de votre demande. Veuillez réessayer plus tard.",

    // language picker
    "public.language.modal.title": "Choisir la langue",
    "public.language.open_picker": "Ouvrir le sélecteur de langue",
    "public.language.current_prefix": "Vous êtes en",
    "public.language.change_country": "Changer de pays"
};

export default fr;